// @flow
export const GENERAL_SECTION: 'general' = 'general';
export const IDENTIFIERS_SECTION: 'identifiers' = 'identifiers';
export const JOBPLACES_SECTION: 'jobplaces' = 'jobplaces';
export const EVENTS_SECTION: 'events' = 'events';
export const SETTINGS_SECTION: 'settings' = 'settings';
